export default "__VITE_ASSET__Be7nr0mi__"